import { Flex, NavigateButton } from '@/components';
import { TenantManagerResourceGuard } from '@/features/authentication/_components/TenantManagerResourceGuard';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { HeaderTab } from '../../_components/HeaderTab';
import { UserSearchForm } from './UserSearchForm';
import { UsersActionsArea } from './UsersActionsArea';
import { UsersTable } from './UsersTable';

export const UsersPage: FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <HeaderTab
        type="users"
        tabBarExtraContent={
          <Flex gap={8}>
            <TenantManagerResourceGuard onlyEdit>
              <NavigateButton path="users/new" text={t('create')} />
            </TenantManagerResourceGuard>
            <UsersActionsArea />
          </Flex>
        }
      />
      <UserSearchForm />
      <UsersTable />
    </>
  );
};
